var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-class":"base-label"}},[(_vm.columnInfo.visible())?_c('span',[_vm._v(" "+_vm._s(_vm.columnInfo.label)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }